<div class="main-content">
	<div class="container-fluid">
		<div class="row">
			<div class="col-md-12">
				<div class="card">
					<div class="card-header card-header-{{ color }}-1">
						<h4 class="card-title d-flex align-items-center">
							<mat-icon class="mr-2 cursor-pointer" (click)="back()">arrow_back</mat-icon>
							Department Required — GL Accounts
						</h4>
						<p class="card-category">
							Toggle which GL accounts require a department (tag) when posting journal entries.
						</p>
					</div>
					<div class="card-body">

						<div class="row mb-3 align-items-center">
							<div class="col-md-5">
								<mat-form-field appearance="outline" class="w-100">
									<mat-label>Search accounts</mat-label>
									<input matInput [(ngModel)]="searchTerm" (ngModelChange)="applyFilter()" placeholder="Code, name, or group" />
									<mat-icon matSuffix>search</mat-icon>
								</mat-form-field>
							</div>
							<div class="col-md-4 d-flex align-items-center">
								<mat-slide-toggle [(ngModel)]="showOnlyRequired" (ngModelChange)="applyFilter()">
									Show required only
								</mat-slide-toggle>
							</div>
							<div class="col-md-3 text-right">
								<span class="text-muted small" *ngIf="!isLoading">
									{{ dataSource.data.length }} account(s) shown
								</span>
							</div>
						</div>

						<div *ngIf="isLoading" class="text-center py-4">
							<mat-progress-spinner mode="indeterminate" diameter="40"></mat-progress-spinner>
						</div>

						<div *ngIf="!isLoading" class="table-responsive">
							<table mat-table [dataSource]="dataSource" matSort class="w-100">

								<ng-container matColumnDef="department_required">
									<th mat-header-cell *matHeaderCellDef>Dept Required</th>
									<td mat-cell *matCellDef="let row">
										<mat-slide-toggle
											[checked]="row.department_required == 1"
											[disabled]="savingCode === row.accountcode"
											(change)="toggle(row, $event.checked)">
										</mat-slide-toggle>
									</td>
								</ng-container>

								<ng-container matColumnDef="accountcode">
									<th mat-header-cell *matHeaderCellDef mat-sort-header>Code</th>
									<td mat-cell *matCellDef="let row">{{ row.accountcode }}</td>
								</ng-container>

								<ng-container matColumnDef="accountname">
									<th mat-header-cell *matHeaderCellDef mat-sort-header>Account Name</th>
									<td mat-cell *matCellDef="let row">{{ row.accountname }}</td>
								</ng-container>

								<ng-container matColumnDef="group">
									<th mat-header-cell *matHeaderCellDef mat-sort-header>Group</th>
									<td mat-cell *matCellDef="let row">{{ row.group }}</td>
								</ng-container>

								<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
								<tr mat-row *matRowDef="let row; columns: displayedColumns;"
									[class.table-active]="row.department_required == 1"></tr>
							</table>

							<mat-paginator [pageSizeOptions]="[25, 50, 100]" showFirstLastButtons></mat-paginator>
						</div>

					</div>
				</div>
			</div>
		</div>
	</div>
</div>
